import { ListProps, useListState } from 'react-stately';
import { ListBoxData } from './types';
import {
  listBoxDynamicItemRenderer,
  listBoxDynamicSectionRenderer,
} from './utils';

export type UseListBoxStateProps<T extends ListBoxData = ListBoxData> =
  ListProps<T>;

export function useListBoxState<T extends ListBoxData = ListBoxData>(
  props: UseListBoxStateProps<T>,
) {
  return useListState({
    selectionMode: 'single',
    ...props,
    children:
      props.children ??
      ((listData) => {
        if (listData.items) {
          return listBoxDynamicSectionRenderer(listData);
        } else {
          return listBoxDynamicItemRenderer(listData);
        }
      }),
  });
}
